/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK IT NEEDS TO BE EXPOSED TO THE USER:
 * @summary Types of links
 * @memberof $w
 * @enum {external:String}
 * @readonly
 */
const LinkType = {
    /**
     * Indicates linking to a Wix page
     */
    PAGE: 'PageLink',

    /**
     * Indicates linking to an external website
     */
    EXTERNAL: 'ExternalLink',
    /**
     * Indicates linking to an email address
     */
    EMAIL: 'EmailLink',
    /**
     * Indicates linking to a download
     */
    DOCUMENT: 'DocumentLink',

    /**
     * Indicates linking to the top of the page
     */
    PAGE_TOP: 'AnchorLink',
    /**
     * Indicates linking to the bottom of the page
     */
    PAGE_BOTTOM: 'AnchorLink',

    /**
     * Indicates linking to a Wix page w/ an Anchor
     */
    ANCHOR: 'AnchorLink',

    /**
     * Indicates linking to a phone number
     */
    PHONE: 'PhoneLink'
};

export default LinkType;
